// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"j4"};